export default __webpack_public_path__ + "static/media/ic24_fct_Instagram.fb2ad6cc.svg";